import { FC, useMemo, useState } from "react"
import Autocomplete from "../form/autocomplete"
import { Organization } from "../../../types"

interface Props {
  selected?: string
  orgs: Organization[]
  direction?: "vertical" | "horizontal"
  onChange: (val: string) => void
}

const OrgAutocomplete: FC<Props> = ({
  selected,
  orgs,
  direction = "horizontal",
  onChange
}) => {
  const [query, setQuery] = useState<string>("")

  const options = useMemo(
    () =>
      orgs
        .filter(org => !!org.name.toLowerCase().includes(query.toLowerCase()))
        .map(o => ({
          id: o.id,
          text: o.name
        })),
    [orgs, query]
  )

  const selectedOption = options.find(opt => opt.id === selected)

  return (
    <div className="max-w-md">
      <Autocomplete
        label="Organization:"
        name="org"
        placeholder="Select organization"
        value={selectedOption}
        query={query}
        options={options}
        direction={direction}
        onChange={option => onChange(option.id)}
        onChangeQuery={setQuery}
      />
    </div>
  )
}

export default OrgAutocomplete
